module.exports = __webpack_public_path__ + "img/bearcubs1.83fad6e3.jpg";